import(/* webpackMode: "eager" */ "/codebuild/output/src2801202248/src/git-codecommit.ap-southeast-2.amazonaws.com/v1/repos/ai-assist-ui/app/home/page.tsx");
